'use strict';

import angular from 'angular';
// import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import 'angular-socket-io';

import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import i18n from 'angular-i18n/ru-ru';
import ngHtmlWindow from 'angular-html-window/src/ngHtmlWindow';
// import ngMessages from 'angular-messages';
// import ngValidationMatch from 'angular-validation-match';


import {
  routeConfig
} from './app.config';

import _Auth from '../components/auth/auth.module';
import account from './account';
import navbar from '../components/navbar/navbar.component';
import footer from '../components/footer/footer.component';
import windows from '../components/windows/windows.component';
import dynamic from '../components/dynamic/dynamic.component';
import storage from '../components/storage/storage.component';
import main from './main/main.component';
import mobile from './mobile/mobile.component';
import constants from './app.constants';
import util from '../components/util/util.module';
import socket from '../components/socket/socket.service';

import './app.css';

angular.module('storageApp', [
  i18n,
  ngCookies, 
  ngResource, 
  ngSanitize, 
  'btford.socket-io', 
  uiRouter,
  uiBootstrap, 
  'ngHtmlWindow',
  _Auth, 
  storage,
  account, 
  navbar, 
  dynamic,
  windows, 
  footer, 
  main, 
  mobile,
  constants, 
  socket, 
  util
])
  .config(routeConfig)
  .run(function($rootScope, $location, Auth) {
    'ngInject';
    // Redirect to login if route requires auth and you're not logged in

    $rootScope.$on('$stateChangeStart', function(event, next) {
      Auth.isLoggedIn(function(loggedIn) {
        if(next.authenticate && !loggedIn) {
          $location.path('/login');
        }
      });
    });
  });

angular.element(document)
  .ready(() => {
    angular.bootstrap(document, ['storageApp'], {
      strictDi: true
    });
  });



// WEBPACK FOOTER //
// ./client/app/app.js